import React, {useEffect, useRef, useState} from "react";
import DataAPI from "../apis/DataAPI";
import Wrapper from "../components/Wrapper";
import {FiSearch} from "react-icons/fi";
import {RxCross2} from "react-icons/rx";
import {Search, Section} from "../components/Sections/Section";
import {Link} from "react-router-dom";
import IconHome from "../components/Sections/IconHome";
import BannerChristmas from "../components/Banner/BannerChristmas";

function HomePage() {
  const [sections, setSections] = useState<Section[] | []>([]);
  const [filter, setFilter] = useState<Search[] | []>([]);
  const [search, setSearch] = useState<string>("");
  const typingTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      const data = await DataAPI.categories();
      if (data.status === "done") {
        const sortedSections = data.data.sort((a, b) => a.order - b.order);
        setSections(sortedSections);
      }
    };
    fetchData();
  }, []);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }
    setSearch(e.target.value);
    typingTimeoutRef.current = setTimeout(() => {
      triggerSearch(e.target.value);
    }, 2000);
  };

  const triggerSearch = async (value: string) => {
    try {
      const response = await DataAPI.search(value);
      setFilter(response.data);
    } catch (error) {
      console.error("Error during search:", error);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }
      triggerSearch(search);
    }
  };

  useEffect(() => {
    return () => {
      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }
    };
  }, []);

  const handleSearchReset = () => {
    setSearch("");
    setFilter([]);
  };

  return (
    <div>
      <Wrapper>
        <div className="container mx-auto p-8 pb-28">
          <h1 className="text-4xl mb-6 text-bblue text-center font-walsheim-bold">
            Comment pouvons-nous vous aider ?
          </h1>
          <BannerChristmas />
          <div className="search mb-20 flex items-center w-[60%] sm:w-[90%] md:w-[90%] lg:w-[60%] mx-auto relative">
            <Search
              className="border p-5 w-full pr-10 text-lg"
              value={search ? search : ""}
              placeholder="Rechercher"
              onChange={handleSearchChange}
              onKeyDown={handleKeyDown}
            />
            <button className="p-2 absolute top-1/2 transform -translate-y-1/2 right-2">
              {search ? (
                <div onClick={handleSearchReset}>
                  <RxCross2 height={70} width={70} color="#375eb4" size={30} />
                </div>
              ) : (
                <FiSearch height={70} width={70} color="#375eb4" size={30} />
              )}
            </button>
          </div>
          {search === "" ? (
            <>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {sections.map((category: Section) => (
                  <Link to={`/${category.id}`} key={category.id}>
                    <Section className="border p-6 rounded-md">
                      <div className="flex items-center mb-4">
                        <IconHome icon={category.id} />
                        <h2 className="ml-4 text-bblue mb-2 text-xl font-walsheim-bold">
                          {category.title}
                        </h2>
                      </div>
                      <p className="text-gray-light">{category.description}</p>
                    </Section>
                  </Link>
                ))}
              </div>
            </>
          ) : (
            <>
              <h2 className="ml-4 text-bblue mb-5 text-xl font-walsheim-bold">
                {"Recherche : "}
                <span className="font-walsheim-regular">{search}</span>
              </h2>
              <div className="">
                {filter.length === 0 && (
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <p className="ml-4">Aucun résultat</p>
                  </div>
                )}
                {filter.map((article: Search) => (
                  <Link
                    to={`/${article.category}/${article.id}`}
                    key={article.id}>
                    <div className="border p-6 rounded-md">
                      <h2 className="text-bblue mb-2 text-xl font-walsheim-bold">
                        {article.title}
                      </h2>
                    </div>
                  </Link>
                ))}
              </div>
            </>
          )}
        </div>
      </Wrapper>
    </div>
  );
}

export default HomePage;
